module.exports = __webpack_public_path__ + "static/img/gj008.d297d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/gj008.png
// module id = CQZ6
// module chunks = 1